var _excluded = ["type", "disabled", "label", "checked", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
export default React.forwardRef(function (_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'checkbox' : _ref$type,
    disabled = _ref.disabled,
    label = _ref.label,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    input = _objectWithoutProperties(_ref, _excluded);
  var id = "".concat(input.name, "-").concat(input.value || type);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(type, " ").concat(disabled ? 'disabled' : '', " ").concat(className)
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/React.createElement("input", _extends({}, input, {
    id: id,
    type: type,
    className: "cb-".concat(type),
    disabled: disabled,
    checked: checked,
    ref: ref
  })), /*#__PURE__*/React.createElement("span", {
    className: "cb-span"
  }), label));
});